/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { EmptyRequest } from '../models/empty.request';
import { SongPhase } from '../models/song-phase.entity';

export type SongPhaseCreatePathVariables = { gameId: string };

@Injectable()
export class SongPhaseService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	/**
	 * @deprecated This method will be deprecated in upcoming versions by GameController.update
	 */
	public create(
		path: SongPhaseCreatePathVariables,
		body: EmptyRequest,
	): Observable<SongPhase> {
		return this.http.post<SongPhase>(
			`${this.config.apiUrl}/api/v2/private/games/${path.gameId}/phases/song`,
			body,
		);
	}
}
